import { Hub } from "../hub"
import { IHub } from "../interfaces/IHub"
import { Dispatch } from "../../utility/common/storeHelper"
import { logHubError } from "../../utility/common/logError"
import { Store } from "../../store/store"
import { processNewEvent } from "../../store/classifiers/actions"
import { ClassifierEventDto } from "../../models/classifierEvent"

const SEND_EVENT = "SendEvent"

const HUB_NAME = "ClassifiersHub"

export class ClassifiersHub {
    private _hub: IHub

    constructor(store: Store) {
        const reduxState = store.getState()
        let useAllTransportSignalR = false

        if (reduxState.config.config.data?.WebConfig.appSettings.useAllTransportSignalR) {
            useAllTransportSignalR = true
        }

        this._hub = new Hub(`/classifiers-hub`, useAllTransportSignalR)
        this.registerServerEvents(store.dispatch)
    }

    async subscribe(projectId: string) {
        await this._hub.subscribe("Subscribe", projectId)
    }

    async unsubscribe(projectId: string) {
        await this._hub.unsubscribe("Unsubscribe", projectId)
    }

    private registerServerEvents(dispatch: Dispatch) {
        this._hub.registerEvent(SEND_EVENT, data => {
            try {
                processNewEvent(dispatch, data as ClassifierEventDto)
            } catch (e) {
                logHubError(HUB_NAME, SEND_EVENT, e)
            }
        })
    }
}
